<template>
    <div class="calls">
        <card type="cinc" class="ReClientCallSubscribe lightTheme"> <!--v-if="objCall.call_record !=''"-->
            <div slot="header">
                <div class="row align-items-center">
                    <div class="col">                
                        <span v-if="objCall.CallFlow == 'in'" class="badge badge-pill badge-primary">Входящий звонок</span>
                        <span v-if="objCall.CallFlow == 'out'" class="badge badge-pill badge-primary">Исходящий звонок</span>
                        
                        <div class="date"><span>{{$GVO.convertDateTimeFromMysql(objCall.dwl_date)}}</span></div>

                        <div class="note-content" v-if="objCall.subscribe_staff_fio != null && objCall.CallFlow == 'in'"><p class="description">Кто ответил: {{objCall.subscribe_staff_fio}}</p></div>
                        <div class="note-content" v-if="objCall.subscribe_staff_fio != null && objCall.CallFlow == 'out'"><p class="description">Кому звонили: {{clientName}}</p></div>

                        <div class="note-content" v-if="objCall.CallStatus != null && objCall.CallStatus != '' || (objCall.CallStatus == 'ANSWER' && objCall.CallStatus == 'CALLING')">
                            <p class="text-success mr-3">Статус звонка:</p>
                            <!-- <p class="text-success">{{objCall.CallStatus}}</p> -->

                            <p v-if="objCall.CallStatus == 'ANSWER'" class="text-success font-weight-bold">Ответил</p> 
                            <p v-if="objCall.CallStatus == 'CALLING'">Звонит</p>
                            
                        </div>  

                        <div class="note-content" v-if="objCall.CalledDID!=''">
                            <p class="text-success mr-3" >Телефон отвечающего: </p>
                            <p class="text-success">{{objCall.CalledDID}}</p>
                        </div>  

                        <!-- <div class="note-content" v-if="objCall.CallStatus != '' 
                            && objCall.CallStatus == 'CANCEL' 
                            && objCall.CallStatus == 'BUSY' 
                            && objCall.CallStatus == 'NOANSWER'
                            && objCall.CallStatus == 'CONGESTION'
                            && objCall.CallStatus == 'CHANUNAVAIL'">
                            <p class="text-success mr-3">Статус звонка:</p>

                            <p v-if="objCall.CallStatus == 'CANCEL'">Отмена вызова</p> 
                            <p v-if="objCall.CallStatus == 'BUSY'">Занято</p>
                            <p v-if="objCall.CallStatus == 'NOANSWER'">Истек таймер ожидания</p> 
                            <p v-if="objCall.CallStatus == 'CONGESTION'">Произошла ошибка во время вызова</p>
                            <p v-if="objCall.CallStatus == 'CHANUNAVAIL'">У вызываемого абонента отсутствует регистрация</p>

                        </div>   -->

                        <div class="note-content" v-if="objCall.duration == 0 "><p>Время ожидания: {{objCall.waiting_time}} сек.</p></div>  
                            <ReAudioComponent
                                v-if="(objCall.FilePath != null && objCall.FilePath != '')"
                                :record="objCall.FilePath"
                                @reload="reloadAudio()"
                                @update-record="handleUpdateRecord(objCall, $event)"
                            />
                        <div v-if="objCall.summary" class="mb-2">{{ objCall.summary }}</div>
                    </div>

                </div>
            </div> 
            <!--pre>{{objCall}}</pre-->
        </card>
    </div>
</template>

<script>
import ReAudioComponent from '../ReAudioComponent.vue';



export default {
    name: 'ReClientCallSubscribe',
    components: {
        ReAudioComponent,
    },
    props: {
        counter: String,
        findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
            type: String,
            default: '',            
        },
        objCall: {
            type: Object,
            default: function() {
				return {};
			}
        },
        clientName: String,
  

    },
    data () {
        return {
            ver: 1,            
            strAudioLink: `${this.objCall.FilePath}?r=`+Math.random(),
        }
    },
    computed: {
        // strPhone: function(){
        //     let obj = this.$GVO.SafeParseJson(this.objCall.jdata)
        //     if(typeof obj.phone != 'undefined'){
        //         return 'Телефон клиента: ' + obj.phone;
        //     }
        //     return '';
        // }
    },
    methods: {     
        async reloadAudio(){
            let res = await this.$GVO.Api.PhoneCallApi.call_check_file({flt:{id:this.objCall.id}});
            if(res.success == true){
                this.handleUpdateRecord(this.objCall, res.data.file_name);
            }
            // alert('Перезагружаем разговор '+this.objCall.id);

        },
		handleUpdateRecord(row, newRecord) {
			// Обновляем RecID в объекте строки
			row.FilePath = newRecord;
		},
    },
}
</script>
<style scoped>
.ReClientCallSubscribe {border: 1px solid rgba(1, 176, 224, 0.4)}

.ReClientCallSubscribe .date {
    font-size: 12px;
    color: #9A9A9A;
    margin: 5px 0px;
}
.ReClientCallSubscribe >>> .card-body {padding: 0px 15px 15px 15px;}
.badge-grey {background: #9A9A9A; color: #fff;}
.ReClientCallSubscribe >>> audio {
    outline: none;
	border-radius: 2rem;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.ReClientCallSubscribe >>> figure {margin-bottom: 0px;}
.ReClientCallSubscribe .description{font-size: 14px; color:#9A9A9A;}
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4; background: #f1f6fc!important;}

.ReClientCallSubscribe .note-content {display: flex;}


figure > *{display: inline-block;}
figure > a.a-dwld, figure > a.a-refresh{
    font-size: 35px;
    vertical-align: top;
    margin-top: 10px;
    margin-left: 20px;
    cursor: pointer;
}
a.a-refresh{color: #9e77f3;}
a.a-refresh:hover{color: #01B0E0;}

@media (max-width: 400px) {
    audio {width: 215px;}
}
@media (max-width: 853px) and (min-width: 768px) {
    audio {width: 230px;}
}

</style>
